import { message } from 'antd';
import { GET } from 'src/network/apiHandler';
import config from 'src/globals';
import { FETCH_DOWNLOAD_REQUESTS } from 'src/api/routes';
import {
  SET_DOWNLOAD_REQUESTS_DATA,
  SET_DOWNLOAD_REQUESTS_LOADER,
} from 'src/common/actions/constants';

const { FINANCE_SERVICE_URL } = config;

export const fetchDownloadRequests = (params) => async (dispatch) => {
  try {
    dispatch({ type: SET_DOWNLOAD_REQUESTS_LOADER, data: true });
    const response = await GET(`${FINANCE_SERVICE_URL}${FETCH_DOWNLOAD_REQUESTS}`, params);

    if (response.isSuccess) {
      dispatch({
        type: SET_DOWNLOAD_REQUESTS_DATA,
        data: response.data,
      });
    } else {
      message.error(response.errorMessage || 'Failed to fetch download requests');
    }
  } catch (error) {
    message.error('Failed to fetch download requests');
  } finally {
    dispatch({ type: SET_DOWNLOAD_REQUESTS_LOADER, data: false });
  }
};
